import clsx from 'clsx';
import { ReactNode } from 'react';

export type HeaderProps = {
  title: ReactNode;
  subTitle?: ReactNode;
  children?: ReactNode | ReactNode[];
  withBorder?: boolean;
  className?: string;
  /** When set, actions fill remaining width and use `justify-between` (toolbar spread). */
  actionsSpread?: boolean;
};

export const Header = ({
  children,
  title,
  withBorder = false,
  subTitle,
  className,
  actionsSpread = false,
}: HeaderProps) => (
  <div
    className={clsx(
      'flex h-11 items-center justify-between py-4',
      actionsSpread && 'gap-4',
      className,
      withBorder && 'border-b border-border-primary',
    )}
  >
    <div className={clsx('flex items-center gap-2', actionsSpread && 'min-w-0 shrink-0')}>
      <h1 className="text-t24-sb">{title}</h1>
      {subTitle}
    </div>
    <div className={clsx('flex gap-4', actionsSpread && 'min-w-0 flex-1 justify-between')}>{children}</div>
  </div>
);
